
<template>
  <div>
    <v-layout wrap>
      <v-flex py-8 px-5 xs12 align-self-center text-left>
        <span style="cursor:pointer;font-family: poppins-semibold;font-size:25px">Assistance Facilities</span>
      </v-flex>
      <v-flex xs12 align-self-center>
        <!-- <v-flex :key="markers.length"> -->
        <div id="mapnew5"></div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script
    src="https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyCaccNxbzwR9tMvkppT7bT7zNKjChc_yAw&libraries=visualization,drawing">
</script>
<script>
import axios from "axios";
export default {
  data() {
    return {
      address: [],

      names: [],
      name:[],
      state:[],
      phno:[],
      location: [],
      
      markers: [],
      places: [],
      icons: "",
      mapData: [],
      latt: 0,
      lonn: 0,
      mark: {
        lat: 0,
        lon: 0,
      },
      map3: null,
      marker: [],
      tot: [],

      window_open: true,
    };
  },
  mounted() {
    this.map();
  },
  methods: {
    openWindow() {
      this.window_open = true;
    },

    map() {
      this.map3 = new google.maps.Map(document.getElementById("mapnew5"), {
        zoom: 5,
        center: { lat: 14.38, lng: 81.12 },
        // center: { lat: 9.528339, lng: 76.822503 },
        mapTypeId: "terrain",
      });
      this.marker = new google.maps.Marker({
        // position: { lat: this.latt, lng: this.lonn },
        map: this.map3,
        title: "Hello World!",
      });
      axios({
        method: "GET",
        url: "rescue/getlist",
      })
        .then((response) => {
          if (response.data.status) {
            // console.log(response.data.data);
            this.tot = response.data.data;
            for (let i = 0; i < this.tot.length; i++) {
              this.mapData.push(this.tot[i].location);
              this.address.push(this.tot[i].address);
              this.name.push(this.tot[i].name);
              this.state.push(this.tot[i].state);
              this.phno.push(this.tot[i].phone);
            }
            //  console.log("address are", this.names);
            for (let i = 0; i < this.mapData.length; i++) {
              this.lonn = parseFloat(this.mapData[i][0]);
              this.latt = parseFloat(this.mapData[i][1]);
              //  this.location =this.adderss[]
              this.icons = {
                url: require("../assets/logos/mapicon.png"),
                size: new google.maps.Size(46, 50),
                scaledSize: new google.maps.Size(32, 35),
                anchor: new google.maps.Point(0, 50),
              };

              this.marker = new google.maps.Marker({
                position: { lat: this.latt, lng: this.lonn },
                map: this.map3,
                icon: this.icons,
                title: "Hello World!",
              });

              const infowindow = new google.maps.InfoWindow({
                content: String( "<h2>"+ this.name[i]+"</h2>"+"<br>"+ "<h4>"+this.address[i]+"</h4>"+   "<h4>"+ this.state[i]+ "</h4>"+ "<h4>" +"Phone:" +this.phno[i]+ "</h4>"),
                maxWidth: 500,
              });
              this.marker.addListener("click", (eve) => {
                infowindow.open(this.map3, this.marker);
                infowindow.setPosition(eve.latLng);
              });
            }
          }
        })
        .catch({});
    },
    markk(map3, marker) {
      const infowindow = new google.maps.InfoWindow({
        content: "contjmjentString",
      });
      this.marker.addListener("click", () => {
        infowindow.open(map3, marker);
      });
    },
  },
};
</script>

<style>
#mapnew5 {
  height: 1000px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>